export default {
  public: 'earth',
  unlisted: 'group',
  private: 'lock',
  direct: 'message',
  local: 'building',
};
